module.exports = __webpack_public_path__ + "static/media/rebirth_sample_9.64be15ba.jpg";